ProductReviews = require '../../product_reviews/frontend/main'

module.exports = class PartialRenderer
  constructor: (@payload) ->
    @$partialRenderingLoader = $('#partial-rendering-loader')
    return unless @$partialRenderingLoader.length

    $.get('goods/widgets')
      .done(@fetchDone)
      .always(@fetchAlways)

  fetchDone: (html) =>
    return unless html.length

    $widgets = $.parseHTML html
    @$partialRenderingLoader.after $widgets
    $('.lazy-load', $widgets).lazyload {threshold: 200}

  fetchAlways: =>
    @$partialRenderingLoader.hide()
    new ProductReviews @payload
